if ($(".catalog-list").length) {
  $(document).on("mouseenter", ".hover-block__inner", function (e) {
    $(this).parent().next().get(0).swiper.slideTo($(this).index(), 0);
  });

  $(document).on("mouseleave", ".hover-block__inner", function (e) {
    if ($(e.relatedTarget).closest(".card-btns").length) return;

    $(this).parent().next().get(0).swiper.slideTo(0, 0);
  });

  // console.log("####catalog-list");

  function initCatalogCardImageSlider() {
    $(".catalog-list .catalog-card").each((id, el) => {
      const $block = $(el).find(".card-col-img").first();
      const $slides = $block.find(".swiper-slide");

      if ($slides.length > 1) {
        // $block.addClass("product-itmes-no-swipe");

        const $hoverBlock = $('<div class="hover-block"></div>');
        for (let i = 0; i < $slides.length; i++) {
          $hoverBlock.append($('<div class="hover-block__inner"></div>'));
        }

        $block.children().prepend($hoverBlock);
      }

      new Swiper($block.find(".swiper")[0], {
        slidesPerView: "auto",
        loop: true,
        pagination: {
          el: $block.find(".swiper-pagination").get(0),
        },
        breakpoints: {
          768: {
            loop: false,
            noSwipingClass: "product-itmes-no-swipe",
          },
        },
      });
    });
  }

  function initCatalogCardSliders() {
    initCatalogCardImageSlider();
    initProductTagsSlider();
  }

  initCatalogCardImageSlider();
}

$(document).on("click", ".catalog-switcher__elem", function () {
  const $parent = $(this).parent();
  const num = $(this).index();
  console.log("####parent", $parent);

  let $otherSwitchers;

  if ($parent.hasClass("for-tablet")) {
    $otherSwitchers = $(".catalog-switcher:not(.for-tablet) .catalog-switcher__elem");
  } else {
    $otherSwitchers = $(".catalog-switcher.for-tablet .catalog-switcher__elem");
  }
  $otherSwitchers.removeClass("catalog-switcher__elem_active");
  $otherSwitchers.eq(num).addClass("catalog-switcher__elem_active");
});

$(window).on("load", function () {
  if (window.innerWidth <= 1279 && $(".catalog-switcher__elem_table").hasClass("catalog-switcher__elem_active")) {
    $(".catalog-list").addClass("table");
  }
});

$(document).on("mouseenter", ".card-btns__btn", function () {
  if ($(window).outerWidth() < 768) return;

  const $this = $(this);
  let text;

  if ($this.hasClass("card-btns__btn_like")) {
    text = $this.hasClass("added") ? "Убрать из избранного" : "Добавить в избранное";
  }

  if ($this.hasClass("card-btns__btn_compare")) {
    text = $this.hasClass("added") ? "Убрать из сравнения" : "Добавить в сравнение";
  }

  $(".catalog-list").append(
    $(`<div class="card-btns__btn-popup">${text}</div>`).css({
      bottom: `${$(window).outerHeight() + $(window).scrollTop() - $this.offset().top + 8}px`,
      left: `${$this.offset().left + $this.outerWidth() / 2}px`,
    })
  );
});

$(document).on("mouseleave", ".card-btns__btn", function () {
  $(".catalog-list").find(".card-btns__btn-popup").remove();
});

$(document).on("click", ".card-btns__btn", function () {
  $(".catalog-list").find(".card-btns__btn-popup").remove();
});
